var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37488 4.44577H8.10691V12.3747C8.10691 12.4778 8.19128 12.5622 8.29441 12.5622H9.70066C9.80378 12.5622 9.88816 12.4778 9.88816 12.3747V4.44577H11.6249C11.7819 4.44577 11.8686 4.2653 11.7725 4.14343L9.14753 0.819988C9.13 0.797578 9.10758 0.779453 9.082 0.766989C9.05642 0.754525 9.02834 0.748047 8.99988 0.748047C8.97142 0.748047 8.94334 0.754525 8.91775 0.766989C8.89217 0.779453 8.86976 0.797578 8.85222 0.819988L6.22722 4.14108C6.13113 4.2653 6.21785 4.44577 6.37488 4.44577ZM17.578 11.6716H16.1718C16.0686 11.6716 15.9843 11.7559 15.9843 11.8591V15.4684H2.0155V11.8591C2.0155 11.7559 1.93113 11.6716 1.828 11.6716H0.421753C0.318628 11.6716 0.234253 11.7559 0.234253 11.8591V16.4997C0.234253 16.9145 0.569409 17.2497 0.984253 17.2497H17.0155C17.4303 17.2497 17.7655 16.9145 17.7655 16.4997V11.8591C17.7655 11.7559 17.6811 11.6716 17.578 11.6716Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.e3322d355c77a74f6a8bb2c02b143567.svg";
export { ForwardRef as ReactComponent };